export default __webpack_public_path__ + "static/zaborona-27065f6b31a66b046b3ffdad7139cd6b.png";